/**
 * Alif Installment Plan - Product Page Variant Price Updater
 * 
 * This script automatically updates the installment price when product variants change.
 * It listens for variant changes and updates the installment price accordingly.
 */

(function() {
  'use strict';

  // Get currency from sessionStorage (set in liquid file)
  const currency = sessionStorage.getItem("currency") || "Rs.";

  /**
   * Calculate and update the installment price
   * @param {number} price - The product variant price
   */
  function updateInstallmentPrice(price) {
    if (!price || price <= 0) {
      return;
    }

    // Calculate installment price (divided by 3)
    const installmentPrice = Math.floor(price / 3);

    if (installmentPrice > 0) {
      // Select the element to display the installment price
      const priceDiv = document.querySelector(".alif-price-divide");

      if (priceDiv) {
        // Format and display the installment price
        priceDiv.textContent = currency + installmentPrice.toLocaleString();
      }
    }
  }

  /**
   * Get the current product price from the page
   * Works for both single products and variant products
   * Dawn theme typically displays price in elements with class "price" or "price-item"
   */
  function getCurrentProductPrice() {
    // Try multiple selectors that Dawn theme might use
    const priceSelectors = [
      // Variant products (sale price)
      '.price--on-sale .price-item--sale',
      '.price--on-sale .price-item--regular',
      // Single products or regular price
      '.price .price-item--sale',
      '.price .price-item--regular',
      '.price .price-item--last',
      // General product price selectors
      '.product__price .price',
      '.product__price .price-item',
      '[data-product-price]',
      '[data-price]',
      '.price-item.price-item--sale',
      '.price-item.price-item--regular',
      '.price-item.price-item--last',
      // Fallback selectors
      '.product-price',
      '.current-price'
    ];

    for (const selector of priceSelectors) {
      const priceElement = document.querySelector(selector);
      if (priceElement) {
        const priceText = priceElement.textContent || priceElement.innerText;
        if (priceText) {
          // Clean the price text (remove currency symbols, commas, etc.)
          const cleanedPrice = priceText
            .replace(/[^0-9.]/g, "")
            .replace(/^\.+/, "");

          const price = parseFloat(cleanedPrice);
          if (price > 0) {
            return price;
          }
        }
      }
    }

    // Try to get price from data attribute
    const priceElement = document.querySelector('[data-product-price], [data-price]');
    if (priceElement) {
      const dataPrice = priceElement.getAttribute('data-product-price') || 
                       priceElement.getAttribute('data-price');
      if (dataPrice) {
        const price = parseFloat(dataPrice);
        if (price > 0) {
          // Check if it's in cents (Shopify often uses cents)
          return price > 10000 ? price / 100 : price;
        }
      }
    }

    return null;
  }

  /**
   * Initialize the variant price watcher
   */
  function initVariantWatcher() {
    // Listen for variant changes
    // Dawn theme uses custom events or updates the DOM when variants change
    
    // Method 1: Listen for input changes on variant selectors (for variant products)
    const variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        setTimeout(() => {
          const price = getCurrentProductPrice();
          if (price) {
            updateInstallmentPrice(price);
          }
        }, 100);
      });
    });

    // Method 2: Listen for radio button changes (for variant options)
    const variantRadios = document.querySelectorAll('input[type="radio"][name^="option"]');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        setTimeout(() => {
          const price = getCurrentProductPrice();
          if (price) {
            updateInstallmentPrice(price);
          }
        }, 100);
      });
    });

    // Method 3: Use MutationObserver to watch for price changes in the DOM
    // This works for both single products and variant products
    const priceObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const price = getCurrentProductPrice();
          if (price) {
            updateInstallmentPrice(price);
          }
        }
      });
    });

    // Observe price container elements (works for both single and variant products)
    const priceContainers = document.querySelectorAll('.price, .product__price, [data-product-price], [data-price], .price-item');
    priceContainers.forEach(container => {
      priceObserver.observe(container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    // Method 4: Listen for custom events that themes might dispatch
    // Works for both single and variant products
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant && event.detail.variant.price) {
        const price = event.detail.variant.price;
        // Convert from cents if needed (Shopify uses cents)
        updateInstallmentPrice(price > 10000 ? price / 100 : price);
      }
    });

    // Listen for product price update events
    document.addEventListener('product:price:update', function(event) {
      if (event.detail && event.detail.price) {
        const price = event.detail.price;
        updateInstallmentPrice(price > 10000 ? price / 100 : price);
      }
    });

    // Initial price update on page load (works for both single and variant products)
    setTimeout(() => {
      const price = getCurrentProductPrice();
      if (price) {
        updateInstallmentPrice(price);
      }
    }, 500);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantWatcher);
  } else {
    initVariantWatcher();
  }
})();
